import localforage from 'localforage';

class CategoryLookup {
  constructor() {
    this.categoryMap = new Map();
    this.isInitialized = false;
    this.productsStore = localforage.createInstance({
      name: 'Products',
    });
  }

  async initialize() {
    if (this.isInitialized) return;

    try {
      const categories = await this.productsStore.getItem('categories');
      if (categories && Array.isArray(categories)) {
        this.buildCategoryMap(categories);
        this.isInitialized = true;
      }
    } catch (error) {
      console.error('Error initializing category lookup:', error);
    }
  }

  buildCategoryMap(categories) {
    this.categoryMap.clear();

    categories.forEach(category => {
      if (category.id) {
        this.categoryMap.set(category.id, {
          id: category.id,
          name: category.name,
          code: category.code,
        });
      }

      if (category.childrens && Array.isArray(category.childrens)) {
        category.childrens.forEach(child => {
          if (child.id) {
            this.categoryMap.set(child.id, {
              id: child.id,
              name: child.name,
              code: child.code,
              parent: category.id,
              parentName: category.name,
            });
          }
        });
      }
    });
  }

  getCategoryName(categoryId) {
    if (!this.isInitialized || !categoryId) return 'N/A';
    
    const category = this.categoryMap.get(categoryId);
    return category?.name || 'N/A';
  }

  getCategoryCode(categoryId) {
    if (!this.isInitialized || !categoryId) return 'N/A';
    
    const category = this.categoryMap.get(categoryId);
    return category?.code || 'N/A';
  }

  getCategory(categoryId) {
    if (!this.isInitialized || !categoryId) return null;
    
    return this.categoryMap.get(categoryId) || null;
  }

  getAllCategories() {
    if (!this.isInitialized) return [];
    
    return Array.from(this.categoryMap.values());
  }

  refresh() {
    this.isInitialized = false;
    return this.initialize();
  }
}

export const categoryLookup = new CategoryLookup();

export const useCategoryLookup = () => {
  const getCategoryName = (categoryId) => categoryLookup.getCategoryName(categoryId);
  const getCategoryCode = (categoryId) => categoryLookup.getCategoryCode(categoryId);
  const getCategory = (categoryId) => categoryLookup.getCategory(categoryId);
  
  return {
    getCategoryName,
    getCategoryCode,
    getCategory,
    initialize: () => categoryLookup.initialize(),
    refresh: () => categoryLookup.refresh(),
  };
};

export default categoryLookup;